<mat-toolbar class='mat-elevation-z5'>

	<div class='toolbar-item-wrapper'>

		<div class='branding--toolbar--home-logo'></div>

		<button mat-button *ngIf="(authService?.authStatus$ | async)?.isAuthenticated" routerLink='/dashboard'>
			<mat-icon class='button-icon'>home</mat-icon>
			<span class='toolbar-label'>{{ "TOOLBAR.DASHBOARD_ACTION" | translate }}</span>
		</button>
		<button mat-button *ngIf="!(authService?.authStatus$ | async)?.isAuthenticated" routerLink='/'>
			<mat-icon class='button-icon'>home</mat-icon>
			<span class='toolbar-label'>{{ "TOOLBAR.HOME_ACTION" | translate }}</span>
		</button>

		<button mat-button [matMenuTriggerFor]="gotoMenu" *ngIf="(authService?.authStatus$ | async)?.isAuthenticated">
			<mat-icon class='button-icon'>bookmark_border</mat-icon>
			<div class="label-with-icon-container">
				<span class='toolbar-label'>{{ "TOOLBAR.GO_TO" | translate }}</span>
				<mat-icon>expand_more</mat-icon>
			</div>
			<mat-menu #gotoMenu="matMenu">
				<button mat-menu-item routerLink="/myads"><mat-icon>calendar_month</mat-icon>{{ "TOOLBAR.MENUS.USER_MENU_ORDERS" | translate }}</button>
				<button mat-menu-item routerLink="/advertisers" *ngIf="userProfilesService.userHasMultipleCustomers$ | async"><mat-icon>supervisor_account</mat-icon>{{ "TOOLBAR.MENUS.USER_MENU_ADVERTISERS" | translate }}</button>
				<button mat-menu-item routerLink="/notifications"><mat-icon>notifications</mat-icon>{{ "TOOLBAR.MENUS.USER_MENU_NOTIFICATIONS" | translate }}</button>
				<button *ngIf="this.enableChatToPublishers && this.enableChatToPublishers.length > 0" mat-menu-item routerLink="/messages">
					<mat-icon>messages</mat-icon>
					{{ "TOOLBAR.MENUS.USER_MENU_MESSAGES" | translate }}
				</button>
				<button mat-menu-item (click)="showTermsAndConditionsDilaog()"><mat-icon>description</mat-icon>{{ "TOOLBAR.MENUS.TERMS_AND_CONDITIONS" | translate }}</button>
			</mat-menu>
		</button>

		<button mat-button *ngIf="(appConfigService.config$ | async)?.loginEnabled && !(authService.authStatus$ | async)?.isAuthenticated" routerLink="/login">
			<mat-icon class='button-icon'>perm_identity</mat-icon>
			<span *ngIf="(appConfigService.config$ | async)?.registrationEnabled" class='toolbar-label'>{{ "TOOLBAR.LOGIN_OR_CREATE_ACCOUNT_ACTION" | translate }}</span>
			<span *ngIf="!(appConfigService.config$ | async)?.registrationEnabled" class='toolbar-label'>{{ "TOOLBAR.LOGIN_ACTION" | translate }}</span>
		</button>

		<button mat-button [matMenuTriggerFor]="userMenu" *ngIf="(authService?.authStatus$ | async)?.isAuthenticated">
			<mat-icon class='button-icon'>account_circle</mat-icon>

			<div class="label-with-icon-container">
				<span class='toolbar-label'>{{ "TOOLBAR.USER_GREETING" | translate: { firstName: (authService.authStatus$ | async)?.displayName } }}</span>
				<mat-icon>expand_more</mat-icon>
			</div>
		</button>

		<mat-menu #userMenu="matMenu">
			<button mat-menu-item routerLink="/profile"><mat-icon>account_circle</mat-icon>{{ "TOOLBAR.MENUS.USER_MENU_PROFILE" | translate }}</button>

			<button mat-menu-item [matMenuTriggerFor]="languageMenu">
				<mat-icon>language</mat-icon>
				<span>{{ selectedLocale?.displayName }}</span>
			</button>

			<button mat-menu-item (click)="authService.logout()" routerLink="/login"><mat-icon>logout</mat-icon>{{ "TOOLBAR.MENUS.USER_MENU_LOG_OUT" | translate }}</button>
		</mat-menu>

		<button mat-button [matMenuTriggerFor]="languageMenu" *ngIf="!(authService.authStatus$ | async)?.isAuthenticated">
			<mat-icon class='button-icon'>language</mat-icon>
			<span class='toolbar-label'>{{ selectedLocale?.displayName }}</span>
		</button>

		<mat-menu #languageMenu="matMenu">
			<button mat-menu-item *ngFor="let locale of locales" (click)="selectLocale(locale)">
				<mat-icon class="branding--locale-icon" [ngClass]="'branding--locale-icon-' + locale?.localeId "></mat-icon>
				{{ locale.displayName }}
			</button>
		</mat-menu>

		<button mat-button routerLink='/help'>
			<mat-icon class='button-icon'>help</mat-icon>
			<span class='toolbar-label'>{{ "TOOLBAR.HELP_ACTION" | translate }}</span>
		</button>

		<!-- [AKennedy] Removing this from the toolbar to avoid extra CSS to make layout responsive with and without it here (for small screens).
			 Could add back to user menu under a permission. -->
		<!--
		<button mat-button [matMenuTriggerFor]="devMenu" *ngIf="!environment.production">
			<mat-icon class='button-icon'>restaurant_menu</mat-icon>
			<div class="label-with-icon-container">
				<span class='toolbar-label'>Dev menu</span>
				<mat-icon>expand_more</mat-icon>
			</div>
		</button>
	    <mat-menu #devMenu="matMenu">
			<button mat-menu-item disabled>Language Strings Test Modes</button>
			<button mat-menu-item (click)="testLanguageStrings('test_missing_key')">Show key if missing</button>
			<button mat-menu-item (click)="testLanguageStrings('test_missing_cross')">Show cross if missing</button>
			<button mat-menu-item (click)="testLanguageStrings('test_all_keys')">Show all keys</button>
			<button mat-menu-item (click)="testLanguageStrings('test_ticks_and_missing_keys')">Show ticks and missing keys</button>
			<mat-divider></mat-divider>
			<button mat-menu-item routerLink="/selftest">Self Test</button>
		</mat-menu> 
		-->

	</div>

</mat-toolbar>
